module.exports = __webpack_public_path__ + "static/media/1_r_Layer1_70.47_1.2.ca1b7a76.png";